function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTargetRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.036 9.593l-2.18.934 3.405 3.405 2.18-.935-3.405-3.404zm2.49-3.736l-.933 2.179 3.404 3.405.935-2.18-3.406-3.404zM8.758 16.542L2 9.784l4.46-1.911-1.667-1.666 1.414-1.414 1.666 1.666 1.911-4.46 6.758 6.759-1.868 4.359 3.001 3a1.1 1.1 0 11-1.557 1.558l-3-3.001-4.36 1.868z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4c-.748 0-1.476.077-2.189.198l1.82 1.821C16.755 6.015 16.876 6 17 6c6.065 0 11 4.935 11 11s-4.935 11-11 11S6 23.065 6 17c0-.125.015-.245.019-.369l-1.821-1.82A13.044 13.044 0 004 17c0 7.18 5.82 13 13 13s13-5.82 13-13S24.18 4 17 4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 22c-2.65 0-4.802-2.077-4.968-4.686l-1.93.83A6.994 6.994 0 0017 24a7 7 0 007-7 6.994 6.994 0 00-5.857-6.898l-.83 1.93C19.924 12.198 22 14.352 22 17c0 2.757-2.243 5-5 5z",
    fill: props.color
  }));
}

export default SvgIconTargetRexOutline;